[
  {
    "id": "SWW-E8P-L306-001",
    "module": "SpellingWW",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "question": "Hij ... al maanden dat hij wil stoppen. (zeggen)",
    "options": ["zei", "zegt", "heeft gezegd", "gezegd"],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_sterk",
    "familyId": "SWW-VTDT-DUUR-ZEGGEN",
    "conceptId": "vtdt_duur_context_zeggen",
    "variantIndex": 1,
    "explanation": "Bij 'al maanden' gaat het om iets dat eerder begon en nog steeds geldt. Dan past voltooide tijd: hij heeft gezegd.\nHet voltooid deelwoord van 'zeggen' is 'gezegd' (sterk/vaste vorm).",
    "distractorExplanations": {
      "1": "Dit is verleden tijd en klinkt als een afgerond moment. 'Al maanden' wijst op een langere periode.",
      "2": "Dit is tegenwoordige tijd. Bij 'al maanden' past voltooide tijd beter.",
      "3": "Dit is alleen het voltooid deelwoord. Je mist het hulpwerkwoord: heeft gezegd."
    }
  },
  {
    "id": "SWW-E8P-L306-002",
    "module": "SpellingWW",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "question": "De fout werd door niemand ... (zien).",
    "options": ["gezien", "gezieën", "zag", "ziet"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_sterk",
    "familyId": "SWW-LIJDENDE-VORM-ZIEN",
    "conceptId": "passief_werd_vd_zien",
    "variantIndex": 1,
    "explanation": "Dit is een lijdende vorm: werd + voltooid deelwoord.\nVan 'zien' is het voltooid deelwoord: gezien.",
    "distractorExplanations": {
      "1": "Er hoort geen trema in deze vorm. Het is gezien.",
      "2": "Dit is verleden tijd als persoonsvorm, maar 'werd' staat al in de zin. Daarna hoort het voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd en past niet bij 'werd'."
    }
  },
  {
    "id": "SWW-E8P-L306-003",
    "module": "SpellingWW",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "question": "Hij ... de hele dag aan het plan. (werken)",
    "options": ["werkt", "werkte", "heeft gewerkt", "gewerkt"],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_kofschip",
    "familyId": "SWW-VTDT-PERIODE-WERKEN",
    "conceptId": "vtdt_periode_context_werken",
    "variantIndex": 1,
    "explanation": "Bij 'de hele dag' klinkt het als een periode waarvan je het resultaat noemt. Dan past voltooide tijd: hij heeft gewerkt.\nHet voltooid deelwoord van 'werken' is 'gewerkt' (stam eindigt op k, dat zit in 't kofschip, dus -t).",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. Hier past voltooide tijd beter.",
      "2": "Verleden tijd kan soms, maar de zin klinkt hier als een periode die je samenvat: heeft gewerkt.",
      "3": "Dit is alleen het voltooid deelwoord. Je mist het hulpwerkwoord: heeft gewerkt."
    }
  },
  {
    "id": "SWW-E8P-L306-004",
    "module": "SpellingWW",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "question": "Het rapport wordt morgen ... (inleveren).",
    "options": ["ingeleverd", "inleverd", "inleveren", "ingeleverde"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_geen_kofschip",
    "familyId": "SWW-LIJDENDE-VORM-INLEVEREN",
    "conceptId": "passief_wordt_vd_inleveren",
    "variantIndex": 1,
    "explanation": "Lijdende vorm: wordt + voltooid deelwoord.\nVan 'inleveren' is het voltooid deelwoord: ingeleverd. Dus: wordt ingeleverd.",
    "distractorExplanations": {
      "1": "Dit is een d/t-fout. Het voltooid deelwoord is ingeleverd.",
      "2": "Dit is het hele werkwoord. Na 'wordt' hoort een voltooid deelwoord.",
      "3": "Dit is een bijvoeglijke vorm met -e. In deze zin hoort het voltooid deelwoord zonder -e."
    }
  }
]
